/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var NotificationType;

(function (NotificationType) {
  NotificationType["PLAIN_TEXT"] = "plain_text";
  NotificationType["URL"] = "url";
  NotificationType["ENDPOINT"] = "endpoint";
})(NotificationType || (NotificationType = {}));